"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback } from "react";
import { useIsAndroid } from "./use-is-android";

/**
 * 修复视口的函数
 */
export const fixViewport = () => {
  // 目标是重置滚动，让浏览器重新计算布局
  window.scrollTo(0, 0);

  // 尝试通过修改元素样式强制重绘
  const body = document.body;
  const originalHeight = body.style.height;
  body.style.height = "100dvh";
  // 使用 requestAnimationFrame 确保在下一帧应用回来
  requestAnimationFrame(() => {
    body.style.height = originalHeight;
  });
};

/**
 * useSafeKeyboardFix hook
 * A hook to fix the viewport issue on mobile devices when the keyboard is closed.
 * This is a common problem on some Android devices where the viewport is not restored
 * correctly after the keyboard is hidden, leaving a blank space at the bottom of the screen.
 *
 * @returns {() => void} A function to manually trigger the fix.
 */
export const useSafeKeyboardFix = () => {
  const $ = _c(2);
  const isAndroid = useIsAndroid();
  let t0;
  if ($[0] !== isAndroid) {
    t0 = () => {
      setTimeout(() => {
        if (isAndroid) {
          fixViewport();
        }
      }, 100);
    };
    $[0] = isAndroid;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const fix = t0;
  return fix;
};